/**
 * Represents the lifecycle events the viewport search core forwards to every policy.
 */
export default class ViewportSearchEvent {

  /**
   * It represents the core starting; carries the initial location and location type.
   */
  static get Start() {
    return this.getInstance('start');
  }

  /**
   * It represents the user selecting a location from the search bar.
   */
  static get LocationSelected() {
    return this.getInstance('locationSelected');
  }

  /**
   * It represents new map boundaries suggested by the backend for the current results.
   */
  static get BoundsFromBackend() {
    return this.getInstance('boundsFromBackend');
  }

  /**
   * It represents the location type changing; carries the previous and new type.
   */
  static get LocationTypeChanged() {
    return this.getInstance('locationTypeChanged');
  }

  /**
   * It represents the user switching from one State to a different State.
   */
  static get StateChanged() {
    return this.getInstance('stateChanged');
  }

  /**
   * It represents the result type (homes, communities, builders) changing.
   */
  static get ResultTypeChanged() {
    return this.getInstance('resultTypeChanged');
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ViewportSearchEvent(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ViewportSearchEvent, 'instances', { value: {} });
